import {
  FaHome,
  FaWallet,
  FaExchangeAlt,
  FaHistory,
  FaUser,
  FaUsers,
  FaMoneyCheckAlt,
  FaTree,
  FaInfoCircle,
  FaUserPlus,
  FaSignInAlt,
  FaCog,
  FaUserShield,
  FaQuestionCircle,
  FaPaperPlane,
  FaTachometerAlt,
} from "react-icons/fa";

/**
 * Définition des items de menu pour la navigation
 */
export const menuItems = {
  // Liens publics (accessibles sans authentification)
  public: [
    { path: "/", icon: FaHome, label: "Accueil" },
    { path: "/bbt", icon: FaTree, label: "BBT Token" },
    { path: "/faq", icon: FaInfoCircle, label: "FAQ" },
    { path: "/about", icon: FaInfoCircle, label: "À propos", hideFromNav: true },
    {
      path: "/login",
      icon: FaSignInAlt,
      label: "Connexion",
      hideFromNav: true,
    },
    {
      path: "/register",
      icon: FaUserPlus,
      label: "Inscription",
      hideFromNav: true,
    },
  ],

  // Liens privés (nécessitent authentification)
  private: [
    { path: "/wallet", icon: FaWallet, label: "Portefeuille" },
    {
      path: "/transfer-money",
      icon: FaMoneyCheckAlt,
      label: "Transfert & Conversion",
    },
    { path: "/transactions", icon: FaHistory, label: "Transactions" },
    { path: "/affiliation", icon: FaUsers, label: "Affiliation" },
    { path: "/profile", icon: FaUser, label: "Profil", hideFromNav: true }, // Caché par défaut
    { path: "/dashboard", icon: FaHome, label: "Tableau de bord", hideFromNav: true }, // Caché par défaut
    { path: "/settings", icon: FaCog, label: "Paramètres", hideFromNav: true }, // Caché par défaut
    {
      path: "/money-ops",
      icon: FaExchangeAlt,
      label: "Dépôt/Retrait",
      hideFromNav: true, // Caché par défaut
    },
    {
      path: "/p2p-transfer",
      icon: FaPaperPlane,
      label: "Transfert P2P",
    },
    {
      path: "/dex/swap",
      icon: FaExchangeAlt,
      label: "DEX",
    },
  ],

  // Liens Admin (optionnel, si vous voulez un menu admin séparé ou intégré)
  admin: [
    { path: "/admin/dashboard", icon: FaUserShield, label: "Admin Dashboard" },
    { path: "/admin/users", icon: FaUsers, label: "Gérer Utilisateurs" },
    { path: "/admin/settings", icon: FaCog, label: "Admin Settings" },
     // Ajoutez d'autres liens admin ici si nécessaire
  ],
}; 